/**
 * Cloned from Application Engine:
 * `ApplicationEngineTopbarFilterSearch.tsx`
 * — URL/search-params replaced with controlled `value`, `onChange`, and `onSearch` props.
 */
import React, { useEffect, useState } from 'react'
import { Input } from 'antd'

const { Search } = Input

export interface VcnManagementSearchFieldProps {
  value: string
  onChange: (value: string) => void
  onSearch: (value: string) => void
  isDisabled?: boolean
  placeholder?: string
}

export function VcnManagementSearchField({
  value,
  onChange,
  onSearch,
  isDisabled = false,
  placeholder = 'Search Benefit ID, VCN token, last 4, Company name, or Insured name',
}: VcnManagementSearchFieldProps) {
  const [localKeyword, setLocalKeyword] = useState(value)

  useEffect(() => {
    setLocalKeyword(value)
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value
    setLocalKeyword(next)
    onChange(next)
    if (!next) onSearch('')
  }

  const handleSearch = (next: string) => {
    onSearch(next)
  }

  return (
    <Search
      placeholder={placeholder}
      value={localKeyword}
      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
          handleSearch((e.target as HTMLInputElement).value)
        }
      }}
      onChange={handleChange}
      onSearch={handleSearch}
      allowClear
      size="large"
      disabled={isDisabled}
      style={{ flex: 1, minWidth: 0, width: '100%' }}
    />
  )
}
